import { jsx as _jsx } from "react/jsx-runtime";
import { lazy } from 'react';
import OtherLayout from '@/components/layout/OtherLayout';
import { Navigate } from 'react-router-dom';
var LoginPage = lazy(function () { return import('@/modules/login'); });
var ResetPasswordPage = lazy(function () { return import('@/modules/login/ResetPassword'); });
var LoginRoutes = function (userInfo) {
    return {
        path: '/',
        element: _jsx(OtherLayout, {}),
        children: [
            {
                path: 'login',
                element: !userInfo ? _jsx(LoginPage, {}) : _jsx(Navigate, { to: '/', replace: true }),
            },
            {
                path: 'reset-password',
                element: _jsx(ResetPasswordPage, {}),
            },
        ],
    };
};
export default LoginRoutes;
